// generated by genversion
export var version = '4.3.12';
//# sourceMappingURL=version.js.map